import {
    OPTILE_INIT_SUCCEEDED,
    OPTILE_SUBMITTING_SUCCEEDED,
    OPTILE_SUBMITTING_LOADING,
    OPTILE_SUBMITTING_ERROR,
    OPTILE_PAYMENT_AUTORISE
} from '../constants/action-types';

export const optileInitSucceeded = data => ({
    type: OPTILE_INIT_SUCCEEDED,
    payload: data
});

export const optileSubmittingSucceeded = data => ({
    type: OPTILE_SUBMITTING_SUCCEEDED,
    payload: data
});

export const optileSubmittingLoading = isSubmitting => ({
    type: OPTILE_SUBMITTING_LOADING,
    payload: isSubmitting
});

export const optileSubmittingError = message => ({
    type: OPTILE_SUBMITTING_ERROR,
    payload: message
});

export const optilePaymentAutorise = data => ({
    type: OPTILE_PAYMENT_AUTORISE,
    payload: data
});
